// extracted by mini-css-extract-plugin
export default {"table":"AdditionalContracts_table__OfPjs","tooltip__popper":"AdditionalContracts_tooltip__popper__lzknI","tooltip__root":"AdditionalContracts_tooltip__root__sz3fQ"};